import { Input } from '@heroui/react';
import { FilterCheckboxGroup } from '../../../components/ui/filter-checkbox-group';
import { InlineDateRangeSection } from '../../../components/ui/inline-date-range-section';
import {
  USAGE_HISTORY_STATUS_OPTIONS,
  USAGE_HISTORY_TYPE_OPTIONS,
  type UsageHistoryFilters,
} from '../utils/usage-history';
import type { UsageStatus, UsageType } from '../../../api/my-parking-spots';

interface UsageHistoryFiltersFormProps {
  filters: UsageHistoryFilters;
  onChange: (next: UsageHistoryFilters) => void;
}

export function UsageHistoryFiltersForm({ filters, onChange }: UsageHistoryFiltersFormProps) {
  const patch = (partial: Partial<UsageHistoryFilters>) => onChange({ ...filters, ...partial });

  return (
    <div className="flex flex-col gap-5">
      <Input
        aria-label="Buscar por código da vaga"
        placeholder="Buscar por código da vaga..."
        value={filters.search}
        onChange={(e) => patch({ search: e.target.value })}
        className="border border-separator bg-surface-secondary"
      />

      <InlineDateRangeSection
        title="Período"
        startDate={filters.startDate}
        endDate={filters.endDate}
        minDate={null}
        onChange={(startDate, endDate) => patch({ startDate, endDate })}
      />

      <FilterCheckboxGroup
        label="Status"
        description="Marque os status que deseja ver."
        options={USAGE_HISTORY_STATUS_OPTIONS}
        selected={filters.statuses}
        onChange={(statuses) => patch({ statuses: statuses as UsageStatus[] })}
      />

      <FilterCheckboxGroup
        label="Tipo"
        description="Marque os tipos de uso que deseja ver."
        options={USAGE_HISTORY_TYPE_OPTIONS}
        selected={filters.types}
        onChange={(types) => patch({ types: types as UsageType[] })}
      />
    </div>
  );
}
